/**
 * GX Testimonials Carousel — scroll + overflow-aware arrows
 */
(function () {
  function initTestimonialsCarousel(root) {
    if (!root || root.dataset.gxTcInit === '1') return;
    root.dataset.gxTcInit = '1';

    var slider = root.querySelector('[data-gx-tc-slider]');
    var track = root.querySelector('[data-gx-tc-track]');
    var prevBtn = root.querySelector('[data-gx-tc-prev]');
    var nextBtn = root.querySelector('[data-gx-tc-next]');
    if (!track || !slider) return;

    function getScrollStep() {
      var card = track.querySelector('[data-gx-tc-slide]');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 24;
      return card.offsetWidth + gap;
    }

    function updateControls() {
      if (!prevBtn || !nextBtn) return;

      var maxScroll = track.scrollWidth - track.clientWidth;
      var hasOverflow = maxScroll > 4;

      if (hasOverflow) {
        slider.setAttribute('data-gx-tc-overflow', '');
      } else {
        slider.removeAttribute('data-gx-tc-overflow');
      }

      var scrollLeft = track.scrollLeft;
      var isAtStart = scrollLeft <= 8;
      var isAtEnd = scrollLeft >= maxScroll - 8;
      prevBtn.disabled = !hasOverflow || isAtStart;
      nextBtn.disabled = !hasOverflow || isAtEnd;
      prevBtn.setAttribute('aria-disabled', prevBtn.disabled ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', nextBtn.disabled ? 'true' : 'false');
    }

    function scrollByDirection(dir) {
      var step = getScrollStep();
      track.scrollBy({
        left: dir === 'next' ? step : -step,
        behavior: 'smooth'
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByDirection('prev'); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByDirection('next'); });
    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        scrollByDirection('next');
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        scrollByDirection('prev');
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(updateControls);
      ro.observe(track);
    }

    updateControls();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-gx-tc-root]').forEach(initTestimonialsCarousel);
  }

  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:reorder', function (e) { boot(e.target); });
})();
